module.exports = __webpack_public_path__ + "assets/f39e1640631758ce018c96906162a378.png";